<iframe
  style="height: 100%; width: 100%; position: absolute"
  [src]="sanitizedUrl"
  frameborder="0"
  allowfullscreen
  referrerpolicy="strict-origin-when-cross-origin"
  loading="lazy"
></iframe>
